import apiClient from '../lib/apiClient';

export const updateHeathSurvey = async ({
  patientId,
  mood,
  date,
}: {
  patientId: number;
  mood: string;
  date: string;
}) => {
  const response = await apiClient.put(
    `/patients/${patientId}/update_health_feedback`,
    {
      health_feedback: {
        mood,
        date,
      },
    }
  );

  return response.data;
};

export const fetchWeeklyHealthFeedback = async (patientId: number) => {
  const response = await apiClient.get(
    `/patients/${patientId}/weekly_health_feedback`
  );

  return response.data;
};

export const fetchTodaysHealthStatus = async (
  patientId: number,
  date: string
) => {
  const response = await apiClient.get(
    `/patients/${patientId}/show_health_feedback`,
    {
      params: {
        date,
      },
    }
  );

  return response?.data;
};
